export default __webpack_public_path__ + "static/media/cleaning.ef9d659d.jpeg";